export default "__VITE_ASSET__BysMuL$W__"